import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntMotor: SelectDataObject<{ iTrack: string; typ: string; k: number[] }>[] = [
    { i: 0, iTrack: 'unbekannt', t: '(unbekannt)', typ: '', k: [0, 1, 10, 11, 13, 12, 14, 2, 15, 16, 17, 18, 19] },
    { i: 200, iTrack: 'Benzin', t: 'Otto', typ: 'O', k: [0, 1, 10, 11, 13, 12, 14] },
    { i: 201, iTrack: 'Diesel', t: 'Diesel', typ: 'D', k: [0, 2] },
    { i: 203, iTrack: 'Autogas (LPG)', t: 'Autogas (LPG)', typ: 'A', k: [0, 15] },
    { i: 204, iTrack: 'Erdgas (CNG)', t: 'Erdgas (CNG)', typ: 'S', k: [0, 16] },
    { i: 205, iTrack: 'Elektro', t: 'Elektro', typ: 'E', k: [0, 18] },
    { i: 206, iTrack: 'andere', t: 'Hybrid (allgemein)', typ: 'H', k: [0, 10, 11, 13, 12, 14, 2, 15, 16, 17, 18] },
    { i: 208, iTrack: 'Gas', t: 'Gasantrieb (allgemein)', typ: 'G', k: [0, 15, 16, 17, 19] },
    { i: 210, iTrack: 'Hybrid (Benzin/Elektro)', t: 'Hybrid Benzin/Elektro', typ: 'H', k: [0, 10, 11, 13, 12, 14, 18] },
    { i: 211, iTrack: 'Hybrid (Diesel/Elektro)', t: 'Hybrid Diesel/Elektro', typ: 'H', k: [0, 2, 18] },
    { i: 213, iTrack: 'andere', t: 'Bi Fuel (allgemein)', typ: 'B', k: [0, 10, 11, 13, 12, 14, 2, 15, 16, 17, 18] },
    { i: 214, iTrack: 'andere', t: 'Bi Fuel Benzin/Flüssiggas', typ: 'B', k: [0, 10, 11, 13, 12, 14, 15] },
    { i: 215, iTrack: 'andere', t: 'Bi Fuel Benzin/Erdgas', typ: 'B', k: [0, 10, 11, 13, 12, 14, 16] },
    { i: 223, iTrack: 'andere', t: 'Bi Fuel Benzin/Methan', typ: 'B', k: [0, 10, 11, 13, 12, 14, 17] },
    { i: 224, iTrack: 'andere', t: 'Hybrid Erdgas/Elektro', typ: 'H', k: [0, 16, 18] },
    { i: 226, iTrack: 'andere', t: 'Wankel', typ: 'R', k: [0, 10, 11, 13, 12, 14] },
    { i: 227, iTrack: 'Hybrid (Benzin/Elektro)', t: 'Plug-In-Hybrid Benzin/Elektro', typ: 'H', k: [0, 10, 11, 13, 12, 14, 18] },
    { i: 228, iTrack: 'Hybrid (Diesel/Elektro)', t: 'Plug-In-Hybrid Diesel/Elektro', typ: 'H', k: [0, 2, 18] },
    { i: 229, iTrack: 'andere', t: 'Plug-In-Hybrid Erdgas/Elektro', typ: 'H', k: [0, 16, 18] },
    { i: 230, iTrack: 'andere', t: 'Wasserstoff', typ: 'W', k: [0, 19] },
];
export default sIntMotor;
